import Head from 'expo-router/head';

const APP_NAME = 'Flavrly';

export function PageTitle({ title }: { title: string }) {
  return (
    <Head>
      <title>{title ? `${APP_NAME} — ${title}` : APP_NAME}</title>
    </Head>
  );
}
